import { IFileStreamReader } from "../Streams/IFileStreamReader";
import { IHashingAlgorithm } from "./Hash/IHashingAlgorithm";
import { HashingStreamReader } from "./HashingStreamReader";
import { HashType } from "./HashType";
/**
 * Umožňuje proudově hashovat pod ním ležící stream při jeho čtení
 */
export class HashingFileStreamReader extends HashingStreamReader implements IFileStreamReader {
    protected override readonly _streamReader: IFileStreamReader;

    constructor(streamReader: IFileStreamReader, hasher: IHashingAlgorithm) {
        super(streamReader, hasher);
        this._streamReader = streamReader;
    }

    public get name(): string {
        return this._streamReader.name;
    }

    public getHash(hashType: HashType): Promise<string | null> {
        return this._streamReader.getHash(hashType);
    }
}
